/**
 * White Label Branding Configuration
 * 
 * This file centralizes all branding elements to support white labeling.
 * Modify this file to rebrand the application.
 */

const brandingConfig = {
  // Basic Information
  appName: "Taxi Frankenthal",
  companyName: "Minicar-Taxi Frankenthal",

  // Contact Information
  owner: "Musamel Sheikh",
  email: "info@taxi-frankenthal.de",
  phone: "06233 22222",
  address: "Vierlingstraße 32, 67227 Frankenthal",
  website: "https://taxi-frankenthal.de",

  // Legal Information
  copyright: `© ${new Date().getFullYear()} Minicar-Taxi Frankenthal`,

  // Aufsichtsbehörden (rechtlich relevant für Impressum & Datenschutz)
  supervisoryAuthority: {
    name: "Stadtverwaltung Frankenthal (Pfalz)",
    department: "Ordnungsamt – Personenbeförderung",
    address: "Rathausplatz 2, 67227 Frankenthal (Pfalz)",
  },
  dataProtectionAuthority: {
    name: "Der Landesbeauftragte für den Datenschutz und die Informationsfreiheit Rheinland-Pfalz",
    address: "Postfach 30 40, 55020 Mainz",
    phone: "06131 8920-0",
    website: "https://www.datenschutz.rlp.de",
  },

  // Colors
  colors: {
    primary: "#F5C518", // Gelb
    secondary: "#4A4A4A", // Grau
    navbar: "#4A4A4A", // Navbar-Hintergrund Grau
    accent: "#FFFFFF", // Weiß
    success: "#4CAF50", // Green
    error: "#F44336", // Red
    warning: "#FF9800", // Orange
    info: "#2196F3", // Blue
    background: "#FFFFFF", // White
    text: {
      primary: "#333333", // Near Black
      secondary: "#757575", // Medium Gray
      light: "#FFFFFF", // White
    }
  },

  // Logos and Images
  logos: {
    primary: "/assets/hauptlogo.png", // Hauptlogo "Mein Taxi in Frankenthal"
    // Gleiches Hauptlogo, aber ohne den großen transparenten Rand der
    // Originaldatei — dort füllt die Grafik nur die mittleren ~36 % der Höhe.
    // Nur so lässt sich die sichtbare Logogröße im Login direkt steuern.
    loginLogo: "/assets/hauptlogo_beschnitten.png",
    icon: "/assets/schriftzug.png", // Schriftzug mit Telefonnummer
    favicon: "/favicon.ico",
    mobileLogo: "/assets/hauptlogo.png",
  },

  // UI Elements
  ui: {
    borderRadius: "4px",
    buttonStyle: "rounded", // 'rounded', 'square', 'pill'
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
  },

  // Features Config
  features: {
    enableReports: true,
    enableLiveMap: true,
    enableShiftPlanning: true,
  },

  // Social Media
  socialMedia: {
    facebook: "",
    twitter: "",
    instagram: "",
  },
};

export default brandingConfig;